import React from 'react';
import { useIntl } from 'umi';
import { Bubble, Button } from 'tea-component';
import { LoadingOutlined } from '@ant-design/icons';
import { IAnalysisFooterProps } from './types';

import './index.scss';

const AnalysisFooter: React.FC<IAnalysisFooterProps> = (props) => {
  const {
    analysisRunning,
    disableButton = false,
    previewSqlLoading = false,
    beforeNode = null,
    afterNode = null,
    onCancelAnalysis,
    onCalculate,
    onPreviewSQL,
    onClearAll,
  } = props;
  const { formatMessage } = useIntl();

  return (
    <div className="dbl-analysis-footer">
      {beforeNode}
      {analysisRunning ? (
        <Button type="primary" className="dbl-analysis-footer-button" onClick={onCancelAnalysis}>
          {formatMessage({ id: 'dbl_ab_experiment_finish_calculate' })}
          <LoadingOutlined style={{ color: 'white', marginLeft: '5px' }} />
        </Button>
      ) : (
        <Bubble
          dark={true}
          style={{ display: disableButton ? '' : 'none' }}
          arrowPointAtCenter
          placement="top"
          content={
            <div>
              <p>{formatMessage({ id: 'dbl_ab_experiment_not_empty_metric' })}</p>
            </div>
          }
        >
          <Button type="primary" className="dbl-analysis-footer-button" disabled={disableButton} onClick={onCalculate}>
            {formatMessage({ id: 'dbl_ab_experiment_calculate' })}
          </Button>
        </Bubble>
      )}
      <Button htmlType="button" className="dbl-analysis-footer-button" disabled={disableButton} onClick={onClearAll}>
        {formatMessage({ id: 'dbl_ab_experiment_clear' })}
      </Button>
      <Button
        htmlType="button"
        className="dbl-analysis-footer-button"
        disabled={disableButton || previewSqlLoading}
        onClick={onPreviewSQL}
      >
        {formatMessage({ id: 'dbl_ab_experiment_preview_sql' })}
        {previewSqlLoading && (
          <LoadingOutlined style={{ marginLeft: '5px' }} />
        )}
      </Button>
      {afterNode}
    </div>
  );
};

export default AnalysisFooter;
